module.exports = __webpack_public_path__ + "226e31c65942d21a4790e074cb500873.png";